import React from "react"
import propTypes from "prop-types"

const Description = ({ children }) => {
  return (
    <div
      className="card_description"
      dangerouslySetInnerHTML={{
        __html: children
      }}
    />
  )
}

Description.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Description
